/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames';
import { Button, Form } from 'react-bootstrap';
import Flex from '../flex';
import { useAdvanceTableContext } from 'providers/advanceTableProvider';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';

const ManualPaginationFooter = ({
  totalCount,
  pageIndex,
  pageSize,
  onPageSizeChange,
  className,
  rowsPerPageOptions = [25, 50, 75, 100],
  tableKey = 'default',
}) => {
  const { t } = useTranslation();
  const { previousPage, nextPage, getCanPreviousPage, getCanNextPage } =
    useAdvanceTableContext();

  const rangeStart = totalCount === 0 ? 0 : pageSize * pageIndex + 1;
  const rangeEnd = Math.min(pageSize * (pageIndex + 1), totalCount);

  return (
    <Flex
      className={classNames(className, 'align-items-center justify-content-between')}
    >
      <Flex alignItems="center" className="fs-10">
        <p className="mb-0">
          <span className="d-none d-sm-inline-block me-2">
            {rangeStart} {t('toLable')} {rangeEnd} {t('of')} {totalCount}
          </span>
        </p>
        <p className="mb-0 mx-2">{t('rowsPerPage')}:</p>
        <Form.Select
          size="sm"
          className="w-auto"
          value={pageSize}
          onChange={(e) => {
            const value = Number(e.target.value);
            onPageSizeChange(value);
            Cookies.set(`rowsPerPage_${tableKey}`, value);
          }}
        >
          {rowsPerPageOptions.map((value) => (
            <option value={value} key={value}>
              {value}
            </option>
          ))}
        </Form.Select>
      </Flex>

      <Flex
        alignItems="center"
        justifyContent="center"
        className="flex-wrap gap-2 pagination-controls"
      >
        <Button
          size="sm"
          variant={getCanPreviousPage() ? 'primary' : 'tertiary'}
          onClick={() => previousPage()}
          className={classNames({ disabled: !getCanPreviousPage() })}
        >
          {t('previous')}
        </Button>
        <Button
          size="sm"
          variant={getCanNextPage() ? 'primary' : 'tertiary'}
          className={classNames('px-4 ms-2', { disabled: !getCanNextPage() })}
          onClick={() => nextPage()}
        >
          {t('nextLable')}
        </Button>
      </Flex>
    </Flex>
  );
};

export default ManualPaginationFooter;